import { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import { postLoginRedirect } from "../auth/postLoginRedirect";
import "./AuthForm.css";

export default function LoginForm({ onSuccess, onCancel }) {
  const { login, loading } = useAuth();
  const navigate = useNavigate();

  const [username,    setUsername]    = useState("");
  const [password,    setPassword]    = useState("");
  const [rememberMe,  setRememberMe]  = useState(false);
  const [error,       setError]       = useState("");
  const [showPw,      setShowPw]      = useState(false);
  const usernameRef = useRef(null);

  useEffect(() => { usernameRef.current?.focus(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const BASE = process.env.REACT_APP_API_URL || "";
      const res  = await fetch(`${BASE}/auth/login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Name: username.trim(), Password: password.trim(), RememberMe: rememberMe }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || "Login failed"); return; }
      await login(data.access_token);
      onSuccess?.();
      await postLoginRedirect(navigate);
    } catch {
      setError("Login failed");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2 className="auth-title">Login</h2>
      {error && <p className="auth-error">{error}</p>}
      <input ref={usernameRef} type="text" placeholder="Username" value={username}
        onChange={(e) => setUsername(e.target.value)} required />
      <div className="auth-pw-wrap">
        <input type={showPw ? "text" : "password"} placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)} required />
        <button type="button" className="auth-pw-toggle" onClick={() => setShowPw((v) => !v)} tabIndex={-1}>
          {showPw ? <EyeOff size={15} /> : <Eye size={15} />}
        </button>
      </div>
      <label className="auth-remember">
        <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
        Remember me
      </label>
      <div className="auth-actions">
        <button type="submit">Login</button>
        <button type="button" className="auth-cancel" onClick={onCancel}>Cancel</button>
      </div>
      <Link to="/forgot-password" className="auth-forgot">Forgot password?</Link>
    </form>
  );
}
